import React from "react";
import * as ReactDOM from "react-dom/client";

import { TStore } from "@redux/store.types";

import Entry from "./Entry";
import RenderCallback from "./RenderCallback";

const handleLazyImages = () => {
    const images = document.querySelectorAll<HTMLImageElement>(
        'img[loading="lazy"]',
    );
    images.forEach(img => {
        if (img.dataset.src) {
            img.src = img.dataset.src;
        }
    });
};

const AEM = (store: TStore, dataPath?: string) => {
    const components = document.querySelectorAll<HTMLElement>(
        // get all data paths or hubo-react-component classes ( .hrc )
        dataPath ? `div[data-cq-data-path='${dataPath}']` : ".hrc",
    );

    Array.from(components)
        .filter(c => c.closest(".js-modal") === null)
        .forEach(c => doHydration(c, store));

    handleLazyImages();
};

const AEMModal = (store: TStore, element: HTMLElement) => {
    const components = Array.from(
        element.querySelectorAll<HTMLElement>(`div[data-cq-data-path]`),
    );

    components.forEach(c => doHydration(c, store));

    handleLazyImages();
};

const doHydration = async (component: HTMLElement, store: TStore) => {
    const root = ReactDOM.createRoot(component);

    const AEMComponentMapping = window.hydrator.getComponentMap("AEM");

    let componentReference = AEMComponentMapping[component.dataset.cqDataPath!];

    if (!componentReference) {
        console.warn(
            "AEM::MISSING COMPONENT - " + component.dataset.cqDataPath!,
        );
        const { componentMap: FullMapping } = await import(
            "../../../../full-lib/AEMComponents"
        );
        componentReference = FullMapping[component.dataset.cqDataPath!];
    }

    if (!componentReference) {
        console.log(
            "Component nowhere to be found - ",
            component.dataset.cqDataPath,
        );
        return;
    }

    const renderCallback = () => {
        component.classList.contains("hide-while-loading") &&
            component.classList.remove("hide-while-loading");
    };

    root.render(
        <RenderCallback callback={renderCallback}>
            <Entry
                innerHTML={component.innerHTML}
                data={component.dataset}
                store={store}
                componentReference={componentReference}
            />
        </RenderCallback>,
    );
};

export { AEM, AEMModal };
